import { liveQuery } from 'dexie'
import { useEffect, useState } from 'react'
import { projectGame, type Game } from './game'
import { db } from './storage'

export function useActiveGame() {
  const [games, setGames] = useState<Game[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [revision, setRevision] = useState(0)
  const [now, setNow] = useState(Date.now)
  useEffect(() => {
    setLoading(true); setError('')
    const subscription = liveQuery(() => db.games.toArray()).subscribe({
      next: value => { setGames(value); setLoading(false) },
      error: () => { setError('Could not load local game data. Please retry.'); setLoading(false) },
    })
    return () => subscription.unsubscribe()
  }, [revision])
  useEffect(() => {
    const tick = () => setNow(Date.now())
    const timer = window.setInterval(tick,1000)
    document.addEventListener('visibilitychange',tick)
    return () => { clearInterval(timer); document.removeEventListener('visibilitychange',tick) }
  }, [])
  const game = games.find(g => projectGame(g,now).status !== 'ended')
  return { game, now, loading, error, retry: () => setRevision(value => value+1) }
}
